import React from 'react';
import useForm from '../../hooks/formHook';
import { Link } from 'react-router-dom';
import ValidationTypes from '../../util/validationTypes';

import "../../styles/LandingRegister.css";

export default function LandingRegister() {
    const registerFormRules = {
        name: [ValidationTypes.requiredString],
        email: [
            ValidationTypes.requiredString,
            ValidationTypes.validEmail
        ],
        password: [
            ValidationTypes.requiredString, 
            {
                test: (value) => value.length >= 8,
                errorMsg: "Password must be at least 8 characters long"
            }
        ],
        confirmPassword: [
            ValidationTypes.requiredString,
            {
                usesInternalFormData: true,
                test: (value, formData) => value === formData.password,
                errorMsg: "Passwords must match"
            }
        ],
        card: []
    };      

    const { formData, handleChange, handleSubmit, errorMapping } = useForm({
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        card: ''
    }, registerFormRules);

    return (
        <div className="LandingRegister form">
            <div className="top">
                <h1>Create an Account</h1>
                <p>Due today:<span> $11</span>. Cancel at anytime</p>
            </div>
            <form onSubmit={(e) => handleSubmit(e)}>
                <input 
                className={errorMapping.name && 'form-error-input'}
                aria-labelledby="name"
                type="text"
                name="name"
                value={formData.name}
                placeholder="Full name"
                onChange={handleChange} />
                {errorMapping.name && <p className="form-error">{errorMapping.name}</p>}
                <input 
                className={errorMapping.email && 'form-error-input'}
                aria-labelledby="email"
                type="text"
                name="email"
                value={formData.email}
                placeholder="Email address"
                onChange={handleChange} />
                {errorMapping.email && <p className="form-error">{errorMapping.email}</p>}
                <input 
                className={errorMapping.password && 'form-error-input'}
                aria-labelledby="password"
                type="password"
                name="password"
                value={formData.password}
                placeholder="Password (at least 8 characters)"
                onChange={handleChange} />
                {errorMapping.password && <p className="form-error">{errorMapping.password}</p>}
                <input 
                className={errorMapping.confirmPassword && 'form-error-input'}
                aria-labelledby="confirm password"
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                placeholder="Confirm password" 
                onChange={handleChange} />
                {errorMapping.confirmPassword && <p className="form-error">{errorMapping.confirmPassword}</p>}
                <input 
                type="text"
                name="card"
                value={formData.card}
                placeholder="Card number MM/YY CVV" 
                onChange={handleChange} />
                <input 
                type="submit"
                value="Submit Payment &amp; Create Account" />
            </form>
            <p className="fine-print">By clicking “Submit Payment &amp; Create Account” I agree to the <Link to="/terms">Terms</Link> and <Link>Privacy Policy</Link></p>
        </div>
    )
}